import { Navigate, type RouteObject } from 'react-router-dom';
import { PageShell } from './components/layout/PageShell';
import Landing from './pages/Landing';
import Game from './pages/Game';
import History from './pages/History';
import HistoryPlays from './pages/HistoryPlays';
import Replay from './pages/Replay';
import Leaderboard from './pages/Leaderboard';
import Season from './pages/Season';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Unsubscribe from './pages/Unsubscribe';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import VerifyEmail from './pages/auth/VerifyEmail';
import ResetPassword from './pages/auth/ResetPassword';
import GoogleCallback from './pages/auth/GoogleCallback';
import NotFound from './pages/NotFound';

/** Route table from spec 10.1, exported separately so tests can mount it in a MemoryRouter. */
export const routes: RouteObject[] = [
  {
    element: <PageShell />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/play/:difficulty', element: <Game /> },
      { path: '/play/:date/:difficulty', element: <Game /> },
      { path: '/history', element: <History /> },
      { path: '/history/plays', element: <HistoryPlays /> },
      { path: '/history/:date/:difficulty', element: <Replay /> },
      { path: '/leaderboard', element: <Leaderboard /> },
      { path: '/season', element: <Season /> },
      { path: '/season/:key', element: <Season /> },
      { path: '/player/:name', element: <Profile /> },
      // Profile merged into the History overview; keep the old link working.
      { path: '/profile', element: <Navigate to="/history" replace /> },
      { path: '/settings', element: <Settings /> },
      { path: '/about', element: <About /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '/terms', element: <Terms /> },
      { path: '/unsubscribe', element: <Unsubscribe /> },
      { path: '/login', element: <Login /> },
      { path: '/register', element: <Register /> },
      { path: '/verify-email', element: <VerifyEmail /> },
      { path: '/reset-password', element: <ResetPassword /> },
      { path: '/auth/google/callback', element: <GoogleCallback /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];
